var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListAltCheck24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgListAltCheck24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-200v-560 454-85zm-80 80v-720h720v400h-80v-320H200v560h280v80zm574 40L552-222l57-56 85 85 170-170 56 57zM440-440h240v-80H440zm0-160h240v-80H440zM280-440h80v-80h-80zm0-160h80v-80h-80z"
  })));
};
export default SvgListAltCheck24DpE3E3E3Fill0Wght400Grad0Opsz24;